import request from '@/utils/request'

export function fetchTreeList() {
  return request({
    url: `/api/productCategory/treeList/`,
    method: 'get'
  })
}
export function fetchList(parentId, params) {
  return request({
    url: `/api/productCategory/list/${parentId}`,
    method: 'get',
    params
  })
}
export function deleteProductCate(id) {
  return request({
    url: `/api/productCategory/delete/${id}`,
    method: 'post'
  })
}

export function createProductCate(data) {
  return request({
    url: `/api/productCategory/create`,
    method: 'post',
    data
  })
}

export function updateProductCate(id, data) {
  return request({
    url: `/api/productCategory/update/${id}`,
    method: 'post',
    data
  })
}

export function getProductCate(id) {
  return request({
    url: `/api/productCategory/${id}`,
    method: 'get'
  })
}

export function updateShowStatus(data) {
  return request({
    url: `/api/productCategory/update/showStatus`,
    method: 'post',
    data
  })
}

export function updateNavStatus(data) {
  return request({
    url: `/api/productCategory/update/navStatus`,
    method: 'post',
    data
  })
}

export function fetchListWithChildren() {
  return request({
    url: `/api/productCategory/list/withChildren`,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/productCate.js